import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import React from "react";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";

const DatePickerCustomHeaderTwoMonth = ({
  monthDate,
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
}: ReactDatePickerCustomHeaderProps) => {
  // Vérifier si le mois affiché est le mois actuel ou un mois passé
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const displayedMonth = monthDate.getMonth();
  const displayedYear = monthDate.getFullYear();

  // Désactiver le bouton précédent si on est sur le mois actuel ou avant
  const isPreviousDisabled =
    displayedYear < currentYear || (displayedYear === currentYear && displayedMonth <= currentMonth);

  return (
    <div>
      <button
        aria-label="Previous Month"
        className={`react-datepicker__navigation react-datepicker__navigation--previous absolute -top-1 left-0 flex items-center justify-center p-2 rounded-full ${
          isPreviousDisabled
            ? "cursor-not-allowed opacity-50 bg-gray-100 dark:bg-gray-700"
            : "hover:bg-gray-100 dark:hover:bg-gray-700"
        }`}
        style={customHeaderCount === 1 ? { visibility: "hidden" } : {}}
        onClick={isPreviousDisabled ? undefined : decreaseMonth}
        disabled={isPreviousDisabled}
        type="button"
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
          <ChevronLeftIcon className="w-5 h-5" />
        </span>
      </button>
      <span className={`react-datepicker__current-month ${isPreviousDisabled ? "text-gray-400 opacity-75" : ""}`}>
        {monthDate.toLocaleString("fr-FR", {
          month: "long",
          year: "numeric",
        })}
      </span>
      <button
        aria-label="Next Month"
        className="react-datepicker__navigation react-datepicker__navigation--next absolute -top-1 -right-0 flex items-center justify-center p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
        style={customHeaderCount === 1 ? { visibility: "hidden" } : {}}
        type="button"
        onClick={increaseMonth}
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
          <ChevronRightIcon className="w-5 h-5" />
        </span>
      </button>
    </div>
  );
};

export default DatePickerCustomHeaderTwoMonth;
